// Launch: US + Non-US — audience must NOT be restricted to country = US.
import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-military-calisthenics': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-military-calisthenics&exp=web_mil_calisthenics_m_new_upsell~1
			upsell: {
				experiment: {
					'upsell-military-calisthenics-m': () =>
						import('@/modules/Upsell/instances/experiments/web_mil_calisthenics_m_new_upsell'),
				},
			},
		},
	},
]

export default config
